import { useState } from "react";

export default function SubscribeCta() {
  const [email, setEmail] = useState("");
  const [done, setDone] = useState(false);

  return (
    <section id="subscribe" className="w-full bg-foreground-950">
      <div className="container-x py-14 md:py-20">
        <div className="relative overflow-hidden rounded-lg border border-background-50/10 bg-background-50/5 p-7 md:p-12">
          <div className="pointer-events-none absolute -right-10 -top-14 text-[180px] leading-none text-background-50/5">
            <i className="ri-spy-line" />
          </div>
          <div className="relative grid grid-cols-1 items-center gap-8 lg:grid-cols-2">
            <div>
              <span className="inline-flex items-center gap-1.5 rounded-full bg-primary-500/20 px-3 py-1 text-xs font-bold text-primary-200 ring-1 ring-primary-400/30">
                <i className="ri-notification-4-line" />
                订阅 · 持续更新
              </span>
              <h2 className="font-heading mt-4 text-2xl font-black leading-snug text-background-50 md:text-4xl">
                想让深扒现场的每一帧<br />
                都不错过？
              </h2>
              <p className="mt-3 max-w-md text-sm leading-relaxed text-foreground-300">
                留下提醒方式，新深挖帖、热度异动与起底档案归档时第一时间通知你，全程记录不间断。
              </p>
            </div>

            <div>
              {done ? (
                <div className="rounded-md border border-accent-400/40 bg-accent-500/10 p-5 text-sm text-accent-200">
                  <i className="ri-checkbox-circle-fill mr-1 text-accent-400" />
                  已记录，现场更新将推送到你留下的提醒地址。
                </div>
              ) : (
                <div className="rounded-md border border-background-50/10 bg-background-50/5 p-5">
                  <label htmlFor="notify" className="text-xs font-semibold text-foreground-200">
                    你的提醒地址（邮箱 / 手机号）
                  </label>
                  <div className="mt-2 flex flex-col gap-3 sm:flex-row sm:items-center">
                    <input
                      id="notify"
                      type="text"
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                      placeholder="name@example.com"
                      className="w-full flex-1 rounded-md border border-background-50/15 bg-background-50/10 px-4 py-3 text-sm text-background-50 outline-none transition-colors placeholder:text-foreground-500 focus:border-accent-400"
                    />
                    <button
                      type="button"
                      onClick={() => email.trim() && setDone(true)}
                      className="inline-flex whitespace-nowrap items-center justify-center gap-2 rounded-md bg-primary-500 px-5 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-primary-400"
                    >
                      开启更新提醒
                      <i className="ri-send-plane-fill" />
                    </button>
                  </div>
                  <p className="mt-3 text-[11px] text-foreground-500">
                    演示页面，提交不会向服务器发送任何内容，仅演示交互效果。
                  </p>
                </div>
              )}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}